<div class="mat-typography" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>Assign {{data.personalFirearmAssignment?"Personal ":""}}Firearm Asset</h2>
  <mat-dialog-content class="dialog-content">
    <div>
      <div class="crud-item-section"  *ngIf="!data.personalFirearmAssignment">
        Assign/Issue this {{firearmAssetTypeName}} to a Ranger.
      </div>
     <div class="crud-item-section"  *ngIf="data.personalFirearmAssignment">
        Assign/Issue this {{firearmAssetTypeName}} to a Ranger as a Personal {{firearmAssetTypeName}}.
      </div>
    </div>
    
    <div>
      <form [formGroup]="form">

        <div class="crud-item-section">

          <span>
            <mat-form-field matTooltip="Select a Firearm Asset from the list"
              [matTooltipDisabled]="disabledTooltip(this.firearm)" class="crud-item-input-wide">
              <mat-label i18n="@@type.FirearmAssignment.firearm">Firearm Asset</mat-label>
              <input matInput [matAutocomplete]="firearmAutocomplete" formControlName="firearm" id="firearm"
                (ngModelChange)="firearmChanging($event)" [(ngModel)]="item.firearm"
                (ngModelChange)="firearmChanged($event)" #firearm>
              <mat-autocomplete id="firearmAutocomplete" #firearmAutocomplete [displayWith]="firearmDisplay">
                <mat-option>Any</mat-option>
                <mat-option *ngFor="let firearm of firearmSelectionList | async" [value]="firearm" [matTooltip]="firearmDisplay(firearm)">
                  {{firearmDisplay(firearm)}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
        </div>


        <div class="crud-item-section">
          <span>
            <mat-form-field matTooltip="Select a Person from the list"
              [matTooltipDisabled]="disabledTooltip(this.person)" class="crud-item-input-wide">
              <mat-label i18n="@@type.FirearmAssignment.person">Person</mat-label>
              <input matInput [matAutocomplete]="personAutocomplete" formControlName="person" id="person"
                (ngModelChange)="personChanging($event)" [(ngModel)]="item.person"
                (ngModelChange)="personChanged($event)" #person>
              <mat-autocomplete id="personAutocomplete" #personAutocomplete [displayWith]="personDisplay">
                <mat-option>Any</mat-option>
                <mat-option *ngFor="let person of personSelectionList | async" [value]="person">
                  {{personDisplay(person)}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
        </div>

        <div class="crud-item-section">
          <mat-form-field matTooltip="Comments" class="crud-item-input-verywide">
            <mat-label i18n="@@type.FirearmAssignment.comments">Comments</mat-label>
            <textarea matInput formControlName="comments" id="comments" [(ngModel)]="item.comments" maxlength="1000"
              placeholder="Comments">
          </textarea>
          </mat-form-field>
        </div>
      </form>
    </div>


  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" [disabled]="!isAssignFirearmEnabled()" (click)="assignFirearm()">Create Assignment Request</button>
    <button mat-raised-button color="accent" (click)="closeDialog()">Close</button>
  </mat-dialog-actions>
  <div class="crud-editor-error-list" *ngIf="getFormErrorList().length > 0">
    <br>
    <h2>Errors:</h2>
    <div *ngFor="let error of getFormErrorList()" class="crud-editor-err-msg">{{error}}</div>
  </div>
</div>